/**
 * Created by Aleksandr on 02.05.2024
 */

const PiggyBankMissionLogic = function (mission, isNewMission) {
    this.mission = mission;
    this.newState = false;

    this.load(this.mission.details);

    if (isNewMission) {
        this.init();
    } else if (!this.getProduct()) {
        this.mission.complete();
    }
};

PiggyBankMissionLogic.prototype.init = function () {
    this.level = PiggyBankMissionLogic.CalcLevel();

    if (!this.getProduct()) {
        this.mission.complete();
        return;
    }

    this.load({
        level: this.level,
        amount: this.getStartAmount()
    });

    this.mission.details = this.getInfo();

    PushHelper.cancelPush(PUSHES.PIGGY_BANK_FULL);
};

PiggyBankMissionLogic.prototype.getInfo = function () {
    return {
        level: this.level,
        amount: this.mission.result,
        nudgeDay: this.nudgeDay || undefined
    };
};

PiggyBankMissionLogic.prototype.saveProgress = function () {
    this.mission.update(0, this.getInfo());
};

PiggyBankMissionLogic.prototype.load = function (data) {
    this.level = data.level || 0;
    this.mission.result = data.amount || 0;
    this.nudgeDay = data.nudgeDay || 0;
    this.lastShownAmount = this.mission.result;
    this.sideBarAmount = this.mission.result;
};

PiggyBankMissionLogic.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }
    game.rewards.piggyBank = this.getLevelReward();
};

PiggyBankMissionLogic.prototype.add = function (amount) {
    if (this.isFull()) {
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value: amount });
    this.mission.logEvent(Mission.EVENTS.MISSION_ACTION, { once: true });

    const unlocked = this.mission.result < this.getBaseAmount() && this.mission.result + amount >= this.getBaseAmount();

    this.mission.result += amount;

    if (unlocked) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.PIGGY_BANK}_unlocked`);
        this.newState = true;
    }

    if (this.isFull()) {
        this.mission.result = Math.min(this.mission.result, this.getMaxAmount());
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.PIGGY_BANK}_full`);
        PushHelper.sendPush(PUSHES.PIGGY_BANK_FULL, PiggyBankMissionLogic.FULL_PUSH_TIMEOUT);
    }

    this.saveProgress();
};

PiggyBankMissionLogic.prototype.getStartAmount = function () {
    return Math.round(this.getBaseAmount() - PiggyBankMissionLogic.WINS_TO_MINIMAL * this.getLevelReward());
};

PiggyBankMissionLogic.prototype.getBaseAmount = function () {
    return RewardsConfig.PiggyBank.hard[this.level];
};

PiggyBankMissionLogic.prototype.getLevelReward = function () {
    return RewardsConfig.PiggyBank.levelReward.hard[this.level];
};

PiggyBankMissionLogic.prototype.getMaxAmount = function () {
    return Math.round(this.getBaseAmount() * PiggyBankMissionLogic.MAX_COEF / PiggyBankMissionLogic.WINS_TO_FULFILL) * PiggyBankMissionLogic.WINS_TO_FULFILL;
};

PiggyBankMissionLogic.prototype.getCurrentPrice = function () {
    return this.getProduct().getCurrentPrice();
};

PiggyBankMissionLogic.prototype.getProgressGoals = function () {
    return [this.getBaseAmount(), this.getMaxAmount()];
};

PiggyBankMissionLogic.prototype.calculateProgress = function (amount) {
    return amount / this.getMaxAmount();
};

PiggyBankMissionLogic.prototype.getLastShowAmountProgress = function () {
    return this.lastShownAmount;
};

PiggyBankMissionLogic.prototype.setLastShowAmountProgress = function (amount) {
    this.lastShownAmount = amount;
};

PiggyBankMissionLogic.prototype.isFull = function () {
    return this.mission.result >= this.getMaxAmount();
};

PiggyBankMissionLogic.prototype.wantToShowNewState = function () {
    return this.newState;
};

PiggyBankMissionLogic.prototype.resetNewState = function () {
    this.newState = false;
};

PiggyBankMissionLogic.prototype.processEvent = function (options) {
    this.add(options.amount);
    this.updateSideBarAmount();
};

PiggyBankMissionLogic.prototype.getStage = function (amount) {
    if (amount >= this.getMaxAmount()) {
        return PiggyBankMissionLogic.STAGE_FULL;
    }

    if (amount >= this.getBaseAmount()) {
        return PiggyBankMissionLogic.STAGE_OPENABLE;
    }

    return amount > this.getStartAmount() ? PiggyBankMissionLogic.STAGE_HALF : PiggyBankMissionLogic.STAGE_EMPTY;
};

PiggyBankMissionLogic.prototype.calcStatusInfo = function () {
    const stage = this.getStage(this.sideBarAmount);

    return {
        animation: `idle_${stage}`,
        transition: `open_${stage || PiggyBankMissionLogic.STAGES_AMOUNT}`,
        progressBar: {
            amount: this.sideBarAmount,
            target: this.getMaxAmount()
        }
    };
};

PiggyBankMissionLogic.prototype.updateSideBarAmount = function () {
    this.sideBarAmount = this.mission.result;
    this.mission.updateMissionIcon();
};

PiggyBankMissionLogic.prototype.receiveRewards = function (f) {
    this.mission.receiveIncome(this.mission.result - this.sideBarAmount, () => {
        this.updateSideBarAmount();
        f();
    });
};

PiggyBankMissionLogic.prototype.markNudge = function (day) {
    this.nudgeDay = day;
    this.saveProgress();
};

PiggyBankMissionLogic.prototype.canRemoveSilently = function () {
    return !this.getProduct();
};

PiggyBankMissionLogic.prototype.getProduct = function () {
    return Product.CreateById(PiggyBankMissionLogic.PRODUCTS[this.level], {
        type: "piggy_bank",
        mission: Mission.TYPE_PIGGY_BANK
    });
};

PiggyBankMissionLogic.prototype.getRewardCurrency = function () {
    return "hard";
};

PiggyBankMissionLogic.prototype.getGoal = function (goal) {
    return this.getRewardCurrency() === "soft" ? `@@${goal}` : `$$${goal}`;
};

PiggyBankMissionLogic.prototype.getReward = function () {
    const reward = {};
    reward[this.getRewardCurrency()] = this.mission.result;
    return reward;
};

PiggyBankMissionLogic.prototype.buy = function (callback) {
    if (this.getStage(this.mission.result) < PiggyBankMissionLogic.STAGE_OPENABLE) {
        callback(true);
        return;
    }

    const product = this.getProduct();
    product.reward = this.getReward();

    product.buy((success) => {
        if (success) {
            this.restart();
        }

        callback(success);
    });
};

PiggyBankMissionLogic.prototype.restart = function () {
    this.init();
    this.saveProgress();
};

PiggyBankMissionLogic.prototype.getControls = function () {
    return "MenuBarGoldItem";
};

PiggyBankMissionLogic.prototype.checkAvailableBottomButton = function () {
    return this.lastShownAmount >= this.getBaseAmount();
};

PiggyBankMissionLogic.prototype.getDescriptionText = function () {
    const stage = this.getStage(this.mission.result);

    if (stage === PiggyBankMissionLogic.STAGE_FULL) {
        return "PiggyBankWindow.text1.Full";
    }

    return stage === PiggyBankMissionLogic.STAGE_OPENABLE ? "PiggyBankWindow.desc2" : "PiggyBankWindow.desc1";
};

PiggyBankMissionLogic.RestoreFind = function (context) {
    const mission = Restorable.FindRunningMission(context);
    return mission && mission.logic.getReward() ? mission : undefined;
};

PiggyBankMissionLogic.RestoreGive = function (mission) {
    const reward = mission.logic.getReward();

    mission.logic.restart();

    Restorable.displayWindow("PiggyBankRewardWindow", () => new RewardWindow(reward, { event: cleverapps.EVENTS.EARN.PURCHASE }));
};

PiggyBankMissionLogic.RestoreBoughtReward = function (context) {
    const mission = cleverapps.missionManager.findByType(context.mission);
    return mission && mission.logic && mission.logic.getReward();
};

PiggyBankMissionLogic.MAX_COEF = 1.5;

// Wins past full are lost, so a player who left with a full bank is reminded to break it
PiggyBankMissionLogic.FULL_PUSH_TIMEOUT = cleverapps.parseInterval("1 day");

PiggyBankMissionLogic.CalcLevel = function () {
    const level = cleverapps.paymentsHistory.classify();
    return level === cleverapps.PaymentsHistory.BRACKET_BIGWHALE ? cleverapps.PaymentsHistory.BRACKET_WHALE : level;
};

// piggybank tests new vs old where the old one is on, piggybankOn tests new vs none elsewhere
PiggyBankMissionLogic.IsNewPiggyBank = function () {
    if (cleverapps.config.features.includes("oldpiggybank")) {
        return cleverapps.abExperiments.getGroup(ABExperiments.Tests.piggybank) === "A";
    }

    return cleverapps.abExperiments.getGroup(ABExperiments.Tests.piggybankOn) !== "B";
};

PiggyBankMissionLogic.CanStart = function () {
    return Boolean(connector.payments.getProduct(PiggyBankMissionLogic.PRODUCTS[PiggyBankMissionLogic.CalcLevel()]));
};

PiggyBankMissionLogic.PRODUCTS = ["kit2", "kit10", "kit30", "kit100"];

PiggyBankMissionLogic.WINS_TO_FULFILL = 15;
PiggyBankMissionLogic.WINS_TO_MINIMAL = 10;

PiggyBankMissionLogic.STAGE_EMPTY = 0;
PiggyBankMissionLogic.STAGE_HALF = 1;
PiggyBankMissionLogic.STAGE_OPENABLE = 2;
PiggyBankMissionLogic.STAGE_FULL = 3;
PiggyBankMissionLogic.STAGES_AMOUNT = 4;

Restorable.BY_TYPE["piggy_bank"] = new Restorable({
    location: "main",
    find: PiggyBankMissionLogic.RestoreFind,
    give: PiggyBankMissionLogic.RestoreGive,
    boughtReward: PiggyBankMissionLogic.RestoreBoughtReward
});